module.exports = __webpack_public_path__ + "img/performancekpilogo.d8dbea6e.png";